import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { DefultPageTitleService } from 'src/app/common-services/defult-page-title.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  constructor(
    private PageTitle: DefultPageTitleService,
    private siteTitle: Title,
    private siteMeta: Meta,
) {
  this.PageTitle.mainHeaderTitle.next('');
  this.PageTitle.subHeaderTitle.next('');
}

  ngOnInit(): void {

    this.siteTitle.setTitle('404 | Nagpur Mahanagarpalika Karmachari Sahakari Bank Ltd.');
    this.siteMeta.addTags([
      { name: 'keywords', content: 'Nagpur Mahanagarpalika Karmachari Sahakari Bank Ltd.'},
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Rahul Chamalwar' },
      {name: 'title', content: 'nmpksbank.in - Nagpur Mahanagarpalika Karmachari Sahakari Bank Ltd.'},
      { name: 'site', content: 'nmpksbank.in'},
      { property: 'og:image', content: 'https://nmpksbank.in/assets/img/logo.png'},
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      // { name: 'date', content: '2020-10-31', scheme: 'YYYY-MM-DD' },
      { charset: 'UTF-8' }
    ]);

  }

}
